import React, { useEffect, useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { prism } from 'react-syntax-highlighter/dist/esm/styles/prism';

const WpHelpList = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const itemsPerPage = 20;

  useEffect(() => {
    const storedData = localStorage.getItem('wpHelpData');
    const storedDate = localStorage.getItem('wpHelpDataDate');
    const today = new Date().toDateString();

    if (storedData && storedDate === today) {
      setData(JSON.parse(storedData));
    } else {
      fetch('https://wphelp.banna360.com/api.php')
        .then(response => response.json())
        .then(data => {
          setData(data);
          localStorage.setItem('wpHelpData', JSON.stringify(data));
          localStorage.setItem('wpHelpDataDate', today);
        })
        .catch(error => console.error('Error fetching data:', error));
    }
  }, []);

  const copyToClipboard = (content) => {
    navigator.clipboard.writeText(content).then(() => {
      alert('Code copied to clipboard!');
    }, (err) => {
      console.error('Failed to copy code: ', err);
    });
  };

  // Filter data based on search term
  const filteredData = data.filter(item =>
    item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.content.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="container mx-auto p-5">
      <header className="bg-blue-500 text-white shadow-md">
        <div className="container mx-auto flex justify-between items-center p-4">
          <h1 className="text-2xl font-bold display-md-none">
            WP Help
          </h1>
          <h3 className="text-xs md:w-200 font-normal">WordPress Codes collected by Banna</h3>
          <div className="flex items-center">
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1); // Reset to first page on search
              }}
              className="px-4 py-2 rounded-l-lg text-black"
            />
            <button className="bg-blue-600 px-4 py-2 rounded-r-lg hover:bg-blue-700">
              Search
            </button>
          </div>
        </div>
      </header>
      <div className="grid grid-cols-1 gap-4 mt-4">
        {currentItems.map(item => (
          <div key={item.id} className="bg-white shadow-lg rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-2">{item.title}</h2>
            <div className="relative">
              <SyntaxHighlighter
                language="javascript"
                style={prism}
                className="rounded-lg"
              >
                {item.content}
              </SyntaxHighlighter>
              <button
                className="absolute top-2 right-2 bg-blue-500 text-white py-1 px-2 rounded text-sm hover:bg-blue-600 focus:outline-none flex items-center"
                onClick={() => copyToClipboard(item.content)}
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 mr-1">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z" />
                </svg>
                Copy Code
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      <div className="flex justify-center mt-4">
        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={index}
            onClick={() => paginate(index + 1)}
            className={`mx-1 px-3 py-1 border rounded ${currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-white text-blue-500'
              }`}
          >
            {index + 1}
          </button>
        ))}
      </div>
    </div>
  );
};

export default WpHelpList;